

const myShuffle = new Shuffle(document.querySelector('.my-shuffle'), {
  itemSelector: '.js-item',
  sizer: '.my-sizer-element',
  buffer: 1,
  easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
  speed: 750,
  delimeter: ','
});

const btnContainer = document.querySelector('.btn-group');

btnContainer.addEventListener('click', ev => {
    
    document.querySelectorAll('button').forEach(btn => {
        btn.classList.remove('selected');
     });

    const category = ev.target.dataset.category;
    ev.target.classList.add('selected');    
    myShuffle.filter(category);
}, false)

